import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Dashboard from '@/components/Dashboard';
import Configuration from '@/components/Configuration';
import Token from '@/components/Auth/Token';
import LoginError from '@/components/Auth/LoginError';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/auth/loginerror',
      name: 'LoginError',
      component: LoginError,
    },
    {
      path: '/auth/token',
      name: 'Token',
      component: Token,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/configuration/:configurationHash',
      name: 'ConfigurationEdit',
      component: Configuration,
    },
    {
      path: '/configuration/add',
      name: 'ConfigurationAdd',
      component: Configuration,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js